import { UserAtom } from "@/atoms"
import { useAtom } from "jotai"


export default function () {

    const [user] = useAtom(UserAtom)

    return <h2>{user?.name}</h2>
}